import * as React from 'react';
import Head from '~/common/layout/Head';

export default class LocationListHeader extends React.Component<any, any> {
  filterRef;

  constructor(props) {
    super(props);
    this.filterRef = React.createRef();
  }

  onCreate = (e) => {
    e.preventDefault();

    this.props.onCreate();
  }

  onFilter = (e) => {
    e.preventDefault();

    this.props.onFilter(this.filterRef.current.value);
  }

  render = () => {
    const { title, onCreate, filter } = this.props;

    return (
      <Head headTitle={title}>
        <form onSubmit={this.onFilter}>
          <div className="input--search">
            <a onClick={this.onFilter} href="javascript:void(null)" className="input__icon input--search__btn">
              <span className="i i-search"></span>
            </a>
            <input ref={this.filterRef} type="text" placeholder="Search" defaultValue={filter && filter.q} />
          </div>
        </form>

        {onCreate && <a onClick={this.onCreate} href="javascript:void(null)" className="btn btn--secn btn--lg">Create</a>}
      </Head>
    );
  }
};
